var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnloadCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.042 12.5833C17.042 13.1359 16.8005 13.6658 16.3708 14.0565C15.941 14.4472 15.3581 14.6667 14.7503 14.6667C14.1425 14.6667 13.5596 14.4472 13.1299 14.0565C12.7001 13.6658 12.4587 13.1359 12.4587 12.5833C12.4587 12.0308 12.7001 11.5009 13.1299 11.1102C13.5596 10.7195 14.1425 10.5 14.7503 10.5C15.3581 10.5 15.941 10.7195 16.3708 11.1102C16.8005 11.5009 17.042 12.0308 17.042 12.5833ZM7.87533 12.5833C7.87533 13.1359 7.63388 13.6658 7.20411 14.0565C6.77434 14.4472 6.19145 14.6667 5.58366 14.6667C4.97587 14.6667 4.39298 14.4472 3.96321 14.0565C3.53343 13.6658 3.29199 13.1359 3.29199 12.5833C3.29199 12.0308 3.53343 11.5009 3.96321 11.1102C4.39298 10.7195 4.97587 10.5 5.58366 10.5C6.19145 10.5 6.77434 10.7195 7.20411 11.1102C7.63388 11.5009 7.87533 12.0308 7.87533 12.5833Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 12.583H7.875M12.9167 10.9163V3.83301C12.9167 2.65467 12.9167 2.06551 12.5133 1.69967C12.1118 1.33301 11.4638 1.33301 10.1667 1.33301H3.75C2.45383 1.33301 1.80575 1.33301 1.40333 1.69967C1 2.06467 1 2.65384 1 3.83301V10.4997C1 11.2788 1 11.668 1.18425 11.958C1.30493 12.148 1.47849 12.3058 1.6875 12.4155C2.0065 12.583 2.43458 12.583 3.29167 12.583M13.375 3.41634H15.0259C15.7868 3.41634 16.1672 3.41634 16.4825 3.57884C16.7978 3.74051 16.9931 4.03717 17.3845 4.63051L18.9419 6.98884C19.1363 7.28384 19.2334 7.43217 19.2838 7.59551C19.3333 7.75967 19.3333 7.93134 19.3333 8.27551V10.4997C19.3333 11.2788 19.3333 11.668 19.1491 11.958C19.0284 12.148 18.8548 12.3058 18.6458 12.4155C18.3268 12.583 17.8988 12.583 17.0417 12.583",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20058 7.99967L4.83841 7.02134C4.11333 6.49967 3.75033 6.23967 3.75033 5.91634M3.75033 5.91634C3.75033 5.59301 4.11333 5.33301 4.83841 4.81134L6.20058 3.83301M3.75033 5.91634H10.167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnloadCount);
export default __webpack_public_path__ + "static/media/unloadCount.bb905182a31e293442c5de169c0769b0.svg";
export { ForwardRef as ReactComponent };